import { render, staticRenderFns } from "./CRSwotAnalysis.vue?vue&type=template&id=0fb9a94b"
import script from "./CRSwotAnalysis.vue?vue&type=script&lang=js"
export * from "./CRSwotAnalysis.vue?vue&type=script&lang=js"
import style0 from "./CRSwotAnalysis.vue?vue&type=style&index=0&id=0fb9a94b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports